export function fingerprintTranscript(tx) {
    if (!tx?.entries?.length)
        return "none";
    const len = tx.entries.length;
    const first = (tx.entries[0]?.text || "").slice(0, 40);
    const last = (tx.entries[len - 1]?.text || "").slice(0, 40);
    let h = 0;
    const s = `${len}|${first}|${last}`;
    for (let i = 0; i < s.length; i++)
        h = (h * 31 + s.charCodeAt(i)) >>> 0;
    return `tx-${len}-${h}`;
}
